import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from 'shared';

/** The signed-in user's own newsletter opt-in state (Api::NewsletterSubscriptionController). */
export interface NewsletterSubscriptionState {
  email: string;
  subscribed: boolean;
  /** An active newsletter opt-out — the only state the dashboard widget offers to undo. */
  unsubscribed: boolean;
  /** Hard bounce or spam complaint: blocked from all mail, and not liftable from here. */
  blocked: boolean;
  /** False when there is nothing to undo, the address is blocked, or we are impersonating. */
  can_subscribe: boolean;
}

/**
 * Newsletter opt-in for the logged-in user. The opt-*out* lives on a signed,
 * session-less link in every bulk mail (NewsletterController); this is the way
 * back in from inside the app.
 *
 * The suppression list is keyed by address and global, so subscribing here lifts
 * the opt-out for every sibling site the address is known on.
 */
@Injectable({ providedIn: 'root' })
export class NewsletterSubscriptionService {
  private readonly apiUrl =
    this.environment.apiUrl || this.environment.serverUrl || 'http://localhost:3000/api';

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: any
  ) {}

  status(): Observable<NewsletterSubscriptionState> {
    return this.http.get<NewsletterSubscriptionState>(`${this.apiUrl}/newsletter/subscription`);
  }

  /** Opt back in. Idempotent; returns the state as it is afterwards. */
  subscribe(): Observable<NewsletterSubscriptionState> {
    return this.http.post<NewsletterSubscriptionState>(`${this.apiUrl}/newsletter/subscription`, {});
  }
}
